const subscriptionDetailsKeys = {
  // Subscription Details
  "subscription.details.subscription": "{{type}} subscription",
  "subscription.details.set-to-cancel": "Set to cancel",
  "subscription.details.next-billing": "Next billing period",
  "subscription.details.cancel-date": "Cancellation date",
  "subscription.details.seats": "Seats",
  "subscription.details.discount": "Discount",
  "subscription.details.discount.none": "None",
  "subscription.details.scheduled-change": "Scheduled change",
  "subscription.details.scheduled-change.none": "None",
  "subscription.details.scheduled-change.pending": "{{quantity}} seats from {{date}}",
  "subscription.details.account-savings": "Account Savings",

  // Actions
  "subscription.details.action.manage": "Manage",
  "subscription.details.action.renew": "Renew",
  "subscription.details.action.cancel-scheduled-change": "Cancel change",

  // Alerts
  "subscription.details.alert.cancel": "Your subscription will be cancelled on {{date}}. You will continue to have access until then.",

  // Notifications
  "subscription.details.cancel-scheduled-change.notification.success.title": "Scheduled change cancelled",
  "subscription.details.cancel-scheduled-change.notification.success.message": "Your pending subscription update has been removed.",
  "subscription.details.cancel-scheduled-change.notification.error.title": "Unable to cancel scheduled change",
  "subscription.details.cancel-scheduled-change.notification.error.message": "Please try again or contact support if the problem persists.",
  "subscription.details.cancel-scheduled-change.dialog.title": "Cancel scheduled change?",
  "subscription.details.cancel-scheduled-change.dialog.message": "This will remove the pending subscription update and keep your current subscription unchanged.",
  "subscription.details.cancel-scheduled-change.dialog.confirm": "Cancel scheduled change",

  // Tabs
  "subscription.details.tab": "Subscription {{number}}",
};

export const subscriptionDetails = {
  ...subscriptionDetailsKeys,
};
